import LayoutSidebar from "@/layouts/LayoutSidebar/LayoutSidebar.vue";
import ArticleLayout from "@/layouts/ArticleLayout/ArticleLayout.vue";

export default {
    components: {
        LayoutSidebar,
        ArticleLayout
    },
    data() {
        return {
            layout: LayoutSidebar
        };
    }
};



// WEBPACK FOOTER //
// ./src/pages/Grammar/Detail/GrammarDetail.js